import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { __MapPropsType } from './map.type';
import useBP from 'scripts/useBP';

export default function AdMapComp(props: __MapPropsType) {
    const isMobile = useBP()?.MD_LTE;
    const [value, setValue] = useState<typeof props.initialValue>(props.initialValue ?? [35.7219, 51.3347]);
    const latitude = Form.useWatch('latitude', { form: props.form, preserve: true });
    const longitude = Form.useWatch('longitude', { form: props.form, preserve: true });

    useEffect(() => {
        props.form.setFieldsValue({ latitude: value?.[0], longitude: value?.[1] });
        props.form.setFields([
            { name: 'latitude', errors: undefined },
            { name: 'longitude', errors: undefined },
        ]);
    }, [value]);

    useEffect(() => {
        setValue(props.initialValue ?? [35.7219, 51.3347]);
    }, [props.initialValue?.[0], props.initialValue?.[1]]);

    useEffect(() => {
        if (!value || value[0] !== latitude || value[1] !== longitude) setValue([latitude, longitude]);
    }, [isMobile]);

    if (!value) return null;

    return (
        <props.Map
            onChange={(e) => setValue([e.lat, e.lng])}
            centerFixedIcon
            latitude={value?.[0]}
            longitude={value?.[1]}
        />
    );
}
